import { capitalDesignTokens } from '@opengov/capital-mui-theme'; // Reusable style constants

export const NAV_BAR_MOBILE_BREAKPOINT = 900;
export const NAV_BAR_SMALL_PHONE_BREAKPOINT = 480;

// Navigation menu item spacing
// Sharing as a constant since nav resize controller relies on it
export const NAV_MENU_ITEM_FLEX_GAP = 8;

export const CAPITAL_FOUNDATION_COLORS = capitalDesignTokens.foundations.colors;
export const NAV_COLOR_PALETTE = {
  primaryBlue: CAPITAL_FOUNDATION_COLORS.blurple700,
  primaryGray: CAPITAL_FOUNDATION_COLORS.gray1000,
  secondaryGray: CAPITAL_FOUNDATION_COLORS.gray700,
  tertiaryGray: CAPITAL_FOUNDATION_COLORS.gray300,
  backgroundBlue: CAPITAL_FOUNDATION_COLORS.blurple100,
  foregroundPrimary: 'text.primary',
  interactionsBlue: CAPITAL_FOUNDATION_COLORS.blurple100,
  white: CAPITAL_FOUNDATION_COLORS.white,
  focus: CAPITAL_FOUNDATION_COLORS.blurple700,
  favoriteStar: CAPITAL_FOUNDATION_COLORS.yellow400
};
export const CONTAINER_BOX_SHADOW = '0 2px 4px 0 rgba(19, 21, 23, 0.3)';
export const SUBMENU_BOX_SHADOW = '0px 4px 4px 0px #00000040';

export const CAPITAL_DESIGN_TOKENS = capitalDesignTokens;

export const tooltipOffsetProps = {
  slotProps: {
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -14]
          }
        }
      ]
    }
  }
};
